<div>
    <h5 class="text-start text-primary fw-bold ps-2 ms-1 mt-4">Enter FATCA & Personal Details</h5>
    <!-- <div class="row mx-0 mt-4">
        <div class="pe-5 col-md-12">
            <div class="px-0 mb-4">
                <strong>I am a Tax Resident of </strong>
                <div class="mt-2 d-md-flex row row-cols-auto">
                    <div class="col">
                        <input class="ms-0 form-check-input" name="resident" [(ngModel)]="taxResident" type="radio" value="Y" id="residentyes">
                        <label class="form-check-label ps-2" for="residentyes">India</label>
                    </div>
                    <div class="col">
                        <input class="ms-md-3 form-check-input" name="resident" [(ngModel)]="taxResident" type="radio" value="N" id="residentno">
                        <label class="form-check-label ps-2" for="residentno">Other Countries</label>
                    </div>
                </div>
            </div>
        </div>
    </div> -->
    <div class="card border-0 shadow-sm">
        <div class="card-body">
            <div class="row mx-0">
                <div class="col-lg-6 col-md-6 pe-lg-5 mt-lg-0 mt-4 px-0 mb-md-0 mb-4">
                    <div class="form-floating mt-4">
                        <select class="form-select" [(ngModel)]="countryOFBirth" id="countryOFBirth" [ngClass]="countryOFBirth ? 'optionValue has-value' : ''">
                            <option *ngFor="let list of countryLists; let i = index" [value]="list.Name">{{list.Name}}</option>
                        </select>
                        <label for="countryOFBirth" [ngClass]="countryOFBirth ? '':'form-select-label'">Select country of birth <span class="text-danger">*</span></label>
                    </div>
                </div>
                <div class="col-lg-6 col-md-6 pe-lg-5 mt-lg-0 mt-4 px-0 mb-md-0 mb-4">
                    <div class="form-floating mt-4">
                        <select class="form-select" [(ngModel)]="citizenShip" id="citizenShip" [ngClass]="citizenShip ? 'optionValue has-value' : ''">
                            <option *ngFor="let list of countryLists; let i = index" [value]="list.Name">{{list.Name}}</option>
                        </select>
                        <label for="citizenShip" [ngClass]="citizenShip ? '':'form-select-label'">Select citizenship <span class="text-danger">*</span></label>
                    </div>
                </div>
            </div>
        </div>
    </div>

    <form [formGroup]="fatcaForm" novalidate>
    <div class="card border-0 shadow-sm"*ngIf="taxResident === 'N'">
        <div class="card-body">
            <div class="row mx-0">
                <div class="col-lg-3 px-0">
                    <div class="text-gradient text-left small p-3">Country of Tax Residence</div>
                    <div class="px-md-3 px-0">
                        <select class="form-select mb-2" formControlName="CTR">
                            <option *ngIf="!fatcaForm.controls['CTR'].value" value="">Select Country</option>
                            <option [value]="list.Name" *ngFor="let list of countryList; let i = index">{{list.Name}}</option>
                        </select>
                    </div>
                </div>
                <div class="col-lg-3 px-0">
                    <div class="text-gradient text-left small p-3">Tin Issuing Country</div>
                    <div class="px-md-3 px-0">
                        <select class="form-select mb-2" formControlName="TID">
                            <option *ngIf="!fatcaForm.controls['TID'].value"  value="">Select Country</option>
                            <option [value]="list.Name" *ngFor="let list of countryList; let i = index">{{list.Name}}</option>
                        </select>
                    </div>
                </div>
                <div class="col-lg-3 px-0">
                    <div class="text-gradient text-left small p-3"> Tax Identification Number</div>
                    <div class="px-md-3 px-0">
                        <input type="text" formControlName="TIN" [maxLength]="30" placeholder="Enter Tax Identification Number"  class="form-control mb-2 custom-place" (input)="alphaNumeric($event)">
                        <!-- <span class="text-danger small" *ngIf="fatcaForm.get('TIN')?.hasError('noNumbers') && fatcaForm.get('TIN')?.touched">
                            TIN should be Alphanumeric.
                        </span> -->
                    </div>
                    
                </div>
                <div class="col-lg-3 px-0">
                    <div class="text-gradient text-left small p-3">Document uploaded</div>
                    <div class="px-md-3 px-0">
                        <input type="text" formControlName="ADDRESS" [maxLength]="30" placeholder="Enter Document Name" appAlphabetsOnly class="form-control mb-2 custom-place">

                        <!-- <select class="form-select mb-2" formControlName="ADDRESS">
                            <option value="">Select Address</option>
                            <option value="F">Foreign Address</option>
                            <option value="P">Permanent Address</option>
                        </select> -->
                    </div>
                </div>
            </div>

            <div formArrayName="items">
                <div *ngFor="let item of itemsArr.controls; let i = index">
                    <div [formGroupName]="i"  class="row mx-0 my-3">
                        <div class="col-12 text-end">
                            <span (click)="removeItem(i)" class="small text-primary">Delete</span>
                        </div>
                        <div class="col-lg-3 px-0">
                            <div class="text-gradient text-left small py-3 d-lg-none d-block">Country of Tax Residence</div>
                            <div class="px-md-3 px-0">
                                <select class="form-select mb-3" formControlName="ADDCTR">
                                    <option *ngIf="!getItemsFromArr(i).controls['ADDCTR'].value" value="">Select Country</option>
                                    <option value="{{list.Name}}" *ngFor="let list of countryList; let i = index">{{list.Name}}</option>
                                </select>
                            </div>
                        </div>
                        <div class="col-lg-3 px-0">
                            <div class="text-gradient text-center p-3 small d-lg-none d-block">TIN Issuing Country</div>
                            <div class="px-md-3 px-0">
                                <select class="form-select mb-3" formControlName="ADDTID">
                                    <option *ngIf="!getItemsFromArr(i).controls['ADDTID'].value" value="">Select Country</option>
                                    <option value="{{list.Name}}" *ngFor="let list of countryList; let i = index">{{list.Name}}</option>
                                </select>
                            </div>
                        </div>
                        <div class="col-lg-3 px-0">
                            <div class="text-gradient text-left small p-3 d-lg-none d-block">Tax Identification Number</div>
                            <div class="px-md-3 px-0">
                                <input type="text" formControlName="ADDTIN" [maxLength]="30" placeholder="Enter Tax Identification Number"  class="form-control mb-1 custom-place">
                                <!-- <small class="ms-1 text-danger" *ngIf="getItemsFromArr(i).controls['ADDTIN'].touched && getItemsFromArr(i).get('ADDTIN')?.hasError('noNumbers')">TIN should be Alphanumeric</small> -->
                            </div>
                        </div>
                        <div class="col-lg-3 px-0">
                            <div class="text-gradient text-left small p-3 d-lg-none d-block">Document Uploaded</div>
                            <div class="px-md-3 px-0">
                                <input type="text" formControlName="ADDADDRESS" [maxLength]="30" placeholder="Enter Document Name" appAlphabetsOnly class="form-control mb-1 custom-place">
                                <!-- <select class="form-select mb-3" formControlName="ADDADDRESS">
                                    <option *ngIf="!getItemsFromArr(i).controls['ADDADDRESS'].value" value="">Select Address</option>
                                    <option value="F">Foreign Address</option>
                                    <option value="P">Permanent Address</option>
                                </select> -->
                            </div>
                        </div>
                    </div>
                </div>
            </div>
          
            <div class="text-end" *ngIf="this.itemsArr.length <2">
                <span (click)="addItem(this.itemsArr.length)" class="small text-primary">Add More</span>
            </div>
        </div>
    </div>
    </form>
    <div class="row mx-0 my-3">
        <div class="col-lg-6 col-md-6 pe-lg-5 mt-lg-0 mt-4 px-0">
            <nri-app-img-upld [getFatcaImage]="getFatca" [taxID]="TaxImage1Id" (fatcaID)="fatcaEvent($event)" (imageURL)="imageURL($event)" [imageName]="'TaxImage1'"></nri-app-img-upld>
        </div>
        <div class="col-lg-6 col-md-6 pe-lg-5 mt-lg-0 mt-4 px-0">
            <nri-app-img-upld [additionalImageName]="'Additional Tax'" [getFatcaImage]="getFatca" [taxID]="TaxImage1Id" (fatcaID)="fatcaEvent($event)" (imageURL)="imageURL($event)" [imageName]="'TaxImage1Add'"></nri-app-img-upld>
        </div>
         <div class="col-lg-6 col-md-6 pe-lg-5 mt-lg-0 mt-4 px-0" >
            <nri-app-img-upld [additionalImageName1]="'Additional Tax'" [getFatcaImage]="getFatca" [taxID]="TaxImage1Id" (fatcaID)="fatcaEvent($event)" (imageURL)="imageURL($event)" [imageName]="'AddImg1'"></nri-app-img-upld>
        </div>
        
        
    </div>
    <div class="row mb-3" *ngIf="fatcaArray[0].fatca1">
        <div class="col-lg-6 col-md-6 pe-lg-5 mt-lg-0 mt-4 px-0" >
            <nri-app-img-upld [getFatcaImage]="getFatca1" [taxID]="TaxImage2Id" (fatcaID)="fatcaEvent($event)" (imageURL)="imageURL($event)" [imageName]="'TaxImage2'"></nri-app-img-upld>
        </div>
        <div class="col-lg-6 col-md-6 pe-lg-5 mt-lg-0 mt-4 px-0" >
            <nri-app-img-upld [additionalImageName]="'Additional Tax'" [getFatcaImage]="getFatca1" [taxID]="TaxImage2Id" (fatcaID)="fatcaEvent($event)" (imageURL)="imageURL($event)" [imageName]="'TaxImage2Add'"></nri-app-img-upld>
        </div>
        <div class="col-lg-6 col-md-6 pe-lg-5 mt-lg-0 mt-4 px-0" >
            <nri-app-img-upld [additionalImageName1]="'Additional Tax'" [getFatcaImage]="getFatca1" [taxID]="TaxImage2Id" (fatcaID)="fatcaEvent($event)" (imageURL)="imageURL($event)" [imageName]="'AddImg2'"></nri-app-img-upld>
        </div>
    </div>
    <div class="row mb-3" *ngIf="fatcaArray[0].fatca2">
        <div class="col-lg-6 col-md-6 pe-lg-5 mt-lg-0 mt-4 px-0" >
            <nri-app-img-upld [getFatcaImage]="getFatca2" [taxID]="TaxImage3Id" (fatcaID)="fatcaEvent($event)" (imageURL)="imageURL($event)" [imageName]="'TaxImage3'"></nri-app-img-upld>
        </div>
        <div class="col-lg-6 col-md-6 pe-lg-5 mt-lg-0 mt-4 px-0" >
            <nri-app-img-upld [additionalImageName]="'Additional Tax'" [getFatcaImage]="getFatca2" [taxID]="TaxImage3Id" (fatcaID)="fatcaEvent($event)" (imageURL)="imageURL($event)" [imageName]="'TaxImage3Add'"></nri-app-img-upld>
        </div>
        <div class="col-lg-6 col-md-6 pe-lg-5 mt-lg-0 mt-4 px-0" >
            <nri-app-img-upld [additionalImageName1]="'Additional Tax'" [getFatcaImage]="getFatca2" [taxID]="TaxImage3Id" (fatcaID)="fatcaEvent($event)" (imageURL)="imageURL($event)" [imageName]="'AddImg3'"></nri-app-img-upld>
        </div>
    </div>

    <div class="row mx-0 mt-5">
        <div class="col-lg-6 col-md-6 pe-lg-5 mt-lg-0 mt-4 px-0">
            <div class="form-floating border input-group pan-auto mb-4">
                <div class="form-floating w-25">
                    <select required class="form-select ps-3 border-0" [ngClass]="title ? 'has-value':''"  id="title" [(ngModel)]="title" name="title" (change)="titleError = false;" [disabled]="titleDisabled">
                        <option *ngFor="let value of nameList" [value]="value.value">{{value.label}}</option>
                    </select>                    
                    <label for="title" [ngClass]="title ? '':'form-select-label'">Title <span class="text-danger">*</span></label>
                </div>
                <div class="form-floating w-75">
                    <input type="text" class="form-control text-uppercase my-1 me-2 border-top-0 border-end-0 border-bottom-0 pe-0 ps-3 py-0" autocomplete="off"  maxlength="15" id="name" [(ngModel)]="name" [ngClass]="name ? 'has-value' : ''" name="name" placeholder="Enter Name" [disabled]="nameDisabled">
                <label for="name" class="left">Name<span class="text-danger">*</span></label>
                </div>
            </div>
        </div>
        <div class="col-lg-6 col-md-6 pe-lg-5 mt-lg-0 mt-4 px-0 mb-md-0 mb-4">
            <div class="form-floating"> 
                <input type="text" class="form-control text-uppercase" required autocomplete="off" maxlength="90" [(ngModel)]="relationName" [ngClass]="relationName ? 'has-value' : ''" name="relationName" id="relation" placeholder="Enter Father/Husband Name" appAlphabetsOnly (input)="relationNameEmpty = false;" (blur)="spaceValidation($event)">
                <label for="relation">Father's Name<span class="text-danger">*</span></label>
                <!-- <div class="text-danger small my-3" *ngIf="relationNameEmpty">
                    Please enter father name
                </div> -->
            </div>
        </div>
        <div class="col-lg-6 col-md-6 pe-lg-5 mt-lg-0 mt-4 px-0 mb-md-0 mb-4 fatcaMob">
            <div class="form-floating border mt-4 input-group pan-auto ">
                <ng-autocomplete [data]="countryLists" [searchKeyword]="codeKeyword" [customFilter]="filter" style="width: 80px !important;"
                placeholder="" [itemTemplate]="itemTemplate" [(ngModel)]="countryCode" [ngModelOptions]="{standalone: true}"
                name="source" mdbInput autocomplete="on" (inputChanged)='telcode($event)' (closed)="checkCode()"
                (selected)='selectCodeEvent($event)' (keydown)="restrictEnter($event)" id="countrycodes" 
                required [notFoundTemplate]="notFoundTemplate" #countryCodeInput="ngModel" [disabled]="disableCountrycode">
                </ng-autocomplete>
                
                <label [ngClass]="countryCode ? 'pin-top':''">Code<span class="text-danger">*</span></label>
                <ng-template #itemTemplate let-item>
                    <a [innerHTML]="item.TeleCode"></a> <a [innerHTML]="item.Name"></a>
                </ng-template>

                <ng-template #notFoundTemplate let-notFound>
                    <div [innerHTML]="notFound"></div>
                </ng-template>
                <input type="text" class="form-control my-1 me-2 border-top-0 border-bottom-0 pe-0 ps-3 py-0" autocomplete="off" appDigitOnly  maxlength="15" id="mobiles" [(ngModel)]="nriMobile"  name="nriMobile" disabled placeholder="Enter Mobile Number">
                <label for="mobiles" class="left1">Mobile Number <span class="text-danger">*</span></label>
                <span class="px-3 py-2">
                    <img src="./assets/images/edit_red.svg" style="cursor: pointer;" (click)="mobileEdit()" [ngClass]="{'disabled': disableMobileEdit}" alt="edit" srcset="">
                </span>
                
            </div> 
            <span class="my-2 d-flex">
                <button *ngIf="mobValidatebtn" class="btn btn-primary ms-1 f-14"  (click)="genOTP1()">Update</button>
                <button *ngIf="mobCancel" class="btn btn-primary ms-2 f-14"  (click)="cancelmobotp()">Cancel</button>
            </span>
        </div>
        <div class="col-lg-6 col-md-6 pe-lg-5 mt-lg-0 mt-4 px-0 mb-md-0 mb-4">
            <div class="form-floating mt-4">
                <select class="form-select" [(ngModel)]="Occupation" id="occupation" [ngClass]="Occupation ? 'optionValue has-value' : ''">
                    <option value="" disabled selected hidden></option>
                    <option *ngFor="let list of occupationList; let i = index" [value]="list.OccupationId">{{list.Name}}</option>
                </select>
                <label for="occupation" [ngClass]="Occupation ? '':'form-select-label'">Select Occupation <span class="text-danger">*</span></label>
            </div>
        </div>
        
        <div class="col-lg-6 col-md-6 pe-lg-5 mt-lg-0 mt-4 px-0 mb-md-0 mb-4">
            <div class="form-floating border input-group mt-5 rounded-2">
                <input type="email" class="form-control border-top-0 border-start-0 border-bottom-0 my-1 me-2 pe-0 ps-3 py-0" id="email" [(ngModel)]="nriEmail" name="nriEmail" disabled (input)="emailOnly($event)" placeholder="Enter Email ID" autocomplete="off">
                <label for="email">Email <span class="text-danger">*</span></label>
                <span class="px-3 py-2">
                    <img src="./assets/images/edit_red.svg" style="cursor: pointer;" (click)="emailEdit()" [ngClass]="{'disabled': disableEmailEdit}" alt="edit" srcset="">
                </span>
                
            </div>
            <!-- <span class="px-3 py-1 small fw-bold">
                <span>Email Not verified </span> <a (click)="toastr.info('Under Intergration')" class="text-gradient">Resend Verification Link to Email</a>
             </span> -->
             <span class="mt-2 d-flex">
            <button *ngIf="emailValidatebtn" class="btn btn-primary ms-1 f-14"  (click)="genOTP()">Update</button>
            <button *ngIf="emailCancel" class="btn btn-primary ms-2 f-14"  (click)="cancelotp()">Cancel</button>
            </span>
            <div *ngIf="otptriggerEmail">
                <div class="input-group border w-md-auto form-floating mb-3 rounded-2">
                    <input type="password" id="emotp" (paste)="(false)" name="emailotp" [(ngModel)]="emailOTP" maxlength="4" (input)="numericOnly($event)" class="form-control mt-1 border-top-0 border-start-0 border-bottom-0 border-end-0 pe-0 ps-3 py-0" placeholder="Enter OTP">
                    <span class="px-3 my-2 border-top-0 border-start-0 border-bottom-0 border-end border">
                        <img [src]="showOTP ? './assets/images/mdi_eye.png' : './assets/images/eye.png'" (click)="togglePasswordVisibility()" alt="Toggle OTP Visibility" class="img-fluid">
                    </span>
                    <label for="emotp">Enter OTP <span class="text-danger">*</span></label>
                    
                    <span class="px-3 py-2" id="otptimer">
                        <count-down (reSendTimer)="reSendOTPStatus($event)" *ngIf="!reSendOTP"></count-down>
                        <span *ngIf="reSendOTP" (click)="genOTP()" class="resend">Re-Send OTP</span>
                    </span>
    
                </div>
                <button class="btn btn btn-primary f-14" (click)="validateOTP()">Update Email</button>
            </div>
        </div> 
        
       
        <div class="col-lg-6 col-md-6 pe-lg-5 mt-lg-0 mt-4 px-0 mb-md-0 mb-4">
            <div class="form-floating mt-5 mb-5">
                <select class="form-select " id="AnnualIncome" [(ngModel)]="AnnualIncome" [ngClass]="AnnualIncome ? 'has-value' : ''">
                    <option value="" disabled selected hidden></option>
                    <option *ngFor="let list of incomeList; let i = index" [value]="list.Id">{{list.Values}}</option>
                </select>
                <label for="AnnualIncome" [ngClass]="AnnualIncome ? '':'form-select-label'">Select Annual Income Range (in INR) <span class="text-danger">*</span></label>
            </div>

            <div class="form-floating my-3">
                <select class="form-select " id="tradingExp" [(ngModel)]="tradingExp" [ngClass]="tradingExp ? 'has-value' : ''">
                    <option value="" disabled selected hidden></option>
                    <option *ngFor="let list of tradingExperience; let i = index" [value]="list.TradingExperienceId">{{list.TradingExp}}</option>
                </select>
                <label for="tradingExp" [ngClass]="tradingExp ? '':'form-select-label'">Trading Experience<span class="text-danger">*</span></label>
            </div>
        </div>
    </div>
    </div>

    <div class="row mx-0 mt-5">
        <nri-app-nominee #nominee (updateNomineeStatus)="status($event)"></nri-app-nominee>
    </div>

    <div class="d-flex align-items-end  mx-0 mt-5 pt-5 row">
        <div class="col-6 p-0">
            <button class="btn btn-white border-primary text-primary px-4" (click)="backStage()">Back</button>
        </div>
        <div class="col-6 text-end p-0 pe-md-3">
            <button class="btn btn-primary px-4" [disabled]="!fatcaForm.valid" (click)="stageValidate()">Next</button>
        </div>
    </div>


<ngx-ui-loader [loaderId]="'Fatca'"></ngx-ui-loader>
<app-error-modal #errorComp [errorMessage]="errorMess"></app-error-modal>